import React from "react";

import Linkify from "linkify-react";

import * as Styled from "./ChatMessage.styles";
import { ReactComponent as ReadIcon } from "../../../../../common/assets/images/checkmark-read-icon.svg";
import ArrowRight from "../../../../../common/assets/images/tiny-chat-triangle-right.svg";
import ArrowLeft from "../../../../../common/assets/images/tiny-chat-triangle.svg";
import Tooltip from "../../../../../common/components/Tooltip/Tooltip";
import { AppUserShared } from "../../../../../common/models";
import { IssueUser } from "../../../../../common/models/issueTracking";
import { Flex } from "../../../../../common/styles/reusable/Flex/Flex.styles";
import identifiers from "../../../../../common/util/identifiers.json";

interface Props {
  messageContent: string;
  messageTimestamp: string;
  user: IssueUser;
  isRead?: boolean;
  appUser?: AppUserShared;
}

export default function ChatMessage({ messageContent, messageTimestamp, user, isRead }: Props) {
  return (
    <Flex style={{ marginTop: "1.2rem" }}>
      <Flex style={{ width: "100%" }}>
        {user.role === "REGULAR_USER" && (
          <img
            src={ArrowLeft}
            style={{ position: "relative", left: "1.2rem" }}
            width={22}
            height={18}
          />
        )}

        <Styled.MessageWrap
          style={{
            marginLeft: user.role !== "REGULAR_USER" ? "4.3rem" : "0rem",
            marginRight: user.role === "REGULAR_USER" ? "4.3rem" : "0rem",
          }}
        >
          <Styled.MessageContentWrap>
            <Styled.MessageMetadata>
              <Styled.MessageTimestamp data-testid={identifiers["central.column.comment.time"]}>
                {messageTimestamp}
              </Styled.MessageTimestamp>

              {user.role === "REGULAR_USER" && (
                <div style={{ marginLeft: "1.2rem", display: "flex" }}>
                  {isRead ? (
                    <Tooltip
                      style={{ width: "1.8rem", height: "1.8rem" }}
                      text="Seen"
                      position="top"
                    >
                      <ReadIcon />
                    </Tooltip>
                  ) : (
                    <Tooltip
                      style={{ width: "1.8rem", height: "1.8rem" }}
                      text="Not seen"
                      position="top"
                    >
                      <Styled.NotRead
                        width={18}
                        height={18}
                      />
                    </Tooltip>
                  )}
                </div>
              )}
            </Styled.MessageMetadata>

            <Styled.MessageContent data-testid={identifiers["central.column.comment.msg"]}>
              <Linkify options={{ target: "_blank" }}>{messageContent}&nbsp;&nbsp;&nbsp;&nbsp;</Linkify>
            </Styled.MessageContent>
          </Styled.MessageContentWrap>
        </Styled.MessageWrap>

        {user.role !== "REGULAR_USER" && (
          <img
            src={ArrowRight}
            style={{ position: "relative", left: "-1.2rem" }}
            width={22}
            height={18}
          />
        )}
      </Flex>
    </Flex>
  );
}
